export default "__VITE_ASSET__PHCj26eA__"